<template>
  <b-row>
    <b-col :md="4">
      <b-row>
        <b-col :md="12">
          <div class="mb-3 row col-md-12 justify-content-center">
            <div class="bd-highlight ml-3">
              <b-form-checkbox
                v-b-tooltip.hover
                title="Change to logo"
                v-model="showImage"
                switch
              ></b-form-checkbox>
            </div>
            <div class="bd-highlight">
              <i
                class="fas fa-image"
                :class="showImage ? 'text-primary' : ''"
              ></i>
            </div>
          </div>
          <div class="text-center">
            <b-avatar
              v-if="showImage"
              rounded
              :src="imageData(getShowCompany.logo)"
              size="15rem"
            ></b-avatar>

            <b-avatar
              v-else
              rounded
              :src="imageData(getShowCompany.picture)"
              size="15rem"
            ></b-avatar>
          </div>
          <div class="text-center mt-3">
            <span class="h3">{{ $t("code-qr-company") }}</span>
            <qrcode
              class="mt-2 mx-auto my-auto"
              :padding="6"
              :size="100"
              cls="qrcode"
              :value="getShowCompany.uuid"
            ></qrcode>
            <small class="table-text">{{ getShowCompany.uuid }}</small>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col :md="8" class="mt-4">
      <div>
        <div class="d-flex align-items-center">
          <i class="ri-community-line h2 table-text"></i>
          <span class="h3 ml-1 mr-1"> {{ $t("name") }}: </span>
          <span class="mb-1 table-text"> {{ getShowCompany.name }}</span>
        </div>
        <div class="d-flex align-items-center">
          <i class="ri-phone-line h2 table-text"></i>
          <span class="h3 ml-1 mr-1"> {{ $t("phone") }}: </span>
          <span class="mb-1 table-text"> {{ getShowCompany.phone }}</span>
        </div>
        <div class="d-flex align-items-center">
          <i class="ri-mail-line h2 table-text"></i>
          <span class="h3 ml-1 mr-1"> {{ $t("email") }}: </span>
          <span class="mb-1 table-text"> {{ getShowCompany.email }}</span>
        </div>
        <div class="d-flex align-items-center">
          <i class="ri-map-pin-line h2 table-text"></i>
          <span class="h3 ml-1 mr-1"> {{ $t("country") }}: </span>
          <span
            class="mb-1 table-text"
            v-if="getShowCompany.city ? getShowCompany.city.country : null"
          >
            {{
              getShowCompany.city ? getShowCompany.city.country.name : null
            }}</span
          >
          <span v-else>{{ $t("fail-country") }}</span>
        </div>
        <div class="d-flex align-items-center">
          <i class="ri-map-pin-line h2 table-text"></i>
          <span class="h3 ml-1 mr-1"> {{ $t("city") }}: </span>
          <span class="mb-1 table-text" v-if="getShowCompany.city">
            {{ getShowCompany.city.name }}</span
          >
          <span v-else>{{ $t("fail-city") }}</span>
        </div>
        <div class="d-flex align-items-center">
          <i class="ri-money-dollar-circle-line h2 table-text"></i>
          <span class="h3 ml-1 mr-1"> {{ $t("balance-wahari") }}: </span>
          <span class="mb-1 table-text" v-if="getShowCompany.balance">
            {{ getShowCompany.balance }} MP
          </span>
        </div>
        <div class="d-flex align-items-center">
          <i class="ri-money-dollar-circle-line h2 table-text"></i>
          <span class="h3 ml-1 mr-1"> {{ $t("payment_for_visits") }}: </span>
          <span class="mb-1 table-text" v-if="getPoints.payment_for_visits">
            {{ getPoints.payment_for_visits }} MP
          </span>
        </div>
        <div class="d-flex align-items-center">
          <i class="ri-money-dollar-circle-line h2 table-text"></i>
          <span class="h3 ml-1 mr-1"> {{ $t("payments_per_week") }}: </span>
          <span class="mb-1 table-text" v-if="getPoints.payments_per_week">
            {{ getPoints.payments_per_week }} MP
          </span>
        </div>
      </div>

      <b-row>
        <b-col :md="12" class="mt-3">
          <b-button
            size="sm"
            class="mb-1"
            @click="$refs.addPoints.showModals()"
            variant="warning"
            v-b-tooltip.hover
            :title="$t('add-wahari-points')"
            ><i class="fas fa-dollar-sign"></i>
            {{ $t("add-wahari-points") }}</b-button
          >
          <b-button
            size="sm"
            class="mb-1"
            variant="warning"
            v-b-tooltip.hover
            @click="$refs.updateRewardRate.show(getPoints)"
            :title="$t('update-reward-rate')"
            ><i class="ni ni-shop"></i> {{ $t("update-reward-rate") }}</b-button
          >
        </b-col>
      </b-row>
    </b-col>
    <ModalsAddPoints
      ref="addPoints"
      @refresh="getCompanyPoints($route.params.id)"
    />
    <ModalsRewardRate ref="updateRewardRate" />
  </b-row>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { myRendeImage } from "@/directives/render-Image";
import Qrcode from "v-qrcode/src/index";
import ModalsAddPoints from "../Modals/AddPoints.vue";
import ModalsRewardRate from "../../Visits/Modals/UpdateRewardRate.vue";

export default {
  mixins: [myRendeImage],
  components: {
    Qrcode,
    ModalsAddPoints,
    ModalsRewardRate,
  },
  data() {
    return {
      showImage: false,
      points: 0,
    };
  },
  methods: {
    ...mapActions({
      getCompanyPoints: "getCompanyPoints",
    }),
  },
  computed: {
    ...mapGetters({
      getShowCompany: "getShowCompany",
      getPoints: "getPoints",
    }),
  },
};
</script>